import { useContext, useEffect, useState, lazy, Suspense } from "react";
import { OPCIONES_FILTRO_CEDULA } from "../../../../../utils/filtroCedula";
import IconSolicitarCandidato from "../../../../ui/icons-seleccion/IconSolicitarCandidato";
import ModalSolicitarRegistro from "../../RegistroHabilitado/Modal/ModalSolicitarRegistro";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ColumnVisibilityMenu from "../../../../ui/ColumnVisibilityMenu";
import TableSearchInput from "../../../../ui/TableSearchInput";
import IconBloquear from "../../../../ui/icons-seleccion/IconBloquear";
import IconDescargaNomina from "../../../../ui/icons-seleccion/IconDescargaNomina";
import FiltroGenerico from "../../../../ui/kit-modal/FiltroGenerico";
import InputFiltro from "../../../../ui/kit-modal/Filtros-kit/InputFiltro";
import StateFiltro from "../../../../ui/kit-modal/Filtros-kit/StateFiltro";
import ModalGenerico from "../../../../ui/kit-modal/ModalGenerico";
import ModalDescartarBloquear from "../../../../ui/kit-modal/bloquearDescartar/ModalDescartarBloquear";
import IconDescarte from "../../../../ui/icons-seleccion/IconDescarte";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ModalAvanzarProceso from "../../../../ui/kit-modal/avanzarProceso/ModalAvanzarProceso";
import {
  ESTADO_CITADO,
  GESTION_INGRESO_VISIBLE,
} from "../../../../../utils/estadosGestionIngreso";
import IconCheck from "../../../../ui/icons-seleccion/IconCheck";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import BotonExcelMasterRex from "../../../../ui/excelMasterRex/BotonExcelMasterRex";
import {
  IEstadosExcel,
  IFiltrosExcel,
  IListaFormatoPsicolaboral,
} from "../../../../../interfaces/ISeleccion";
import IconCargando from "../../../../ui/icons-seleccion/IconCargando";
import ModalDownloadPsicolaboral from "../../../../ui/kit-modal/descargaPsicolaboral/ModalDownloadPsicolaboral";
import IconDescargaPsicolaboral from "../../../../ui/kit-svg/icon-preseleccionado/IconDescargaPsicolaboral";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { downloadFichaLegacyByRuts } from "../../../../../services/fichaLegacyService";
const LazyNoProcesados = lazy(
  () => import("../../../../ui/kit-modal/noProcesado/ModalNoProcesadoSeleccion")
);
interface IActionMasive {
  listadoSeleccionado: any;
  localStorageFilter: string;
  setFormFilter: Function;
  formFilter: any;
  handleAvanzarProceso: Function;
  candidates: any;
  setCandidates: Function;
  refreshTable: Function;
  setListadoSeleccionado: Function;
  localStorageSelect: string;
  selectCurrent: any;
  setSelectCurrent: Function;
  tipoDocumentoAll: any;
  setTipoDocumentoAll: Function;
  listaFormatoPsicolaboral: IListaFormatoPsicolaboral[];
  modalPdfDisabled: boolean;
  solicitudes: any;
  setSolicitudes: Function;
  handleClickSolicitarCandidato: Function;
  columnDefinitions: readonly { key: string; label: string }[];
  visibleColumnKeys: string[];
  setVisibleColumnKeys: (keys: string[]) => void;
  isSavingColumns?: boolean;
  isColumnsSynchronized?: boolean | null;
  searchValue?: string;
  onSearch?: (term: string) => void;
}

const ActionMassive = (props: IActionMasive) => {
  const {
    listadoSeleccionado,
    localStorageFilter,
    setFormFilter,
    formFilter,
    handleAvanzarProceso,
    setCandidates,
    refreshTable,
    setListadoSeleccionado,
    localStorageSelect,
    selectCurrent,
    setSelectCurrent,
    tipoDocumentoAll,
    setTipoDocumentoAll,
    listaFormatoPsicolaboral,
    modalPdfDisabled,
    solicitudes,
    setSolicitudes,
    handleClickSolicitarCandidato,
    columnDefinitions,
    visibleColumnKeys,
    setVisibleColumnKeys,
    isSavingColumns,
    isColumnsSynchronized,
    searchValue,
    onSearch,
  } = props;
  const {
    token,
    userId,
    listaCandidatoSeleccionado,
    postGenerarExcel,
    listaNoProcesadosSeleccion,
    putEntrevistaRealizada,
    getListadoPdf,
  } = useContext(SeleccionContext);
  const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
  const [isOpenModalBloquear, setIsOpenModalBloquear] =
    useState<boolean>(false);
  const [isOpenModalDescartar, setIsOpenModalDescartar] =
    useState<boolean>(false);
  const [isOpenModalAvanzar, setIsOpenModalAvanzar] = useState<boolean>(false);
  const [isOpenModalNoProcesado, setIsOpenModalNoProcesado] =
    useState<boolean>(false);
  const [openModalFiltro, setOpenModalFiltro] = useState<boolean>(false);
  const [currentProcesos, setCurrentProcesos] = useState<string[]>([]);
  const [dataObject, setDataObject] = useState<boolean | undefined>(undefined);
  const [isOpenModalDownPsicolaboral, setIsOpenModalDownPsicolaboral] =
    useState<boolean>(false);
  const [isOpenModalSolicitar, setIsOpenModalSolicitar] = useState<boolean>(false);
  const [rutSolicitar, setRutSolicitar] = useState<string[]>([]);
  const [selectedProcesoDestino, setSelectedProcesoDestino] = useState<string | undefined>(undefined);
  const [selectedComentario, setSelectedComentario] = useState<string>("");
  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean | undefined>(
    undefined
  );
  const estadosExcel: IEstadosExcel = {
    porValidar: false,
    preseleccionado: false,
    validado: true,
  };
  const filtrosExcel: IFiltrosExcel = {
    busPerIdList: [],
    reclutador: [],
    estadoRegistro: [],
    nombre: [],
    rut: [],
    proceso: [],
    cliente: [],
    tipoProceso: ["PROFESIONAL"],
    fechaPostulacion: [],
    fechaValidacion: [],
    fechaPreseleccion: [],
    confirmaEntrevista: null,
    transporteTeamwork: null,
    entrevistaRealizada: null,
  };

  useEffect(() => {
    setButtonEnabled(listadoSeleccionado.length > 0);
  }, [listadoSeleccionado]);

  useEffect(() => {
    if (localStorage.getItem(localStorageFilter)) {
      const copyStorage: any = localStorage.getItem(localStorageFilter);
      const dataObject = Object.values(JSON.parse(copyStorage)).some(
        (value: any) => value.length > 0
      );
      setDataObject(dataObject);
    }
  }, [localStorage.getItem(localStorageFilter)]);

  useEffect(() => {
    if (listaCandidatoSeleccionado && listaCandidatoSeleccionado.length > 0) {
      const listProcesos = [...listaCandidatoSeleccionado];
      const arrayProcesos: string[] = listProcesos
        .map(({ grupos }: any) => grupos)
        .flat()
        .map(({ procesos }: any) => procesos)
        .flat()
        .map(({ personas }: any) => personas)
        .flat()
        .map((item: any) => item);
      setCurrentProcesos(arrayProcesos);
    }
  }, [listaCandidatoSeleccionado]);


  const handleClickBloquearCandidato = (): void => {
    setIsOpenModalBloquear(true);
  };

  const handleClickDescartarCandidato = (): void => {
    setIsOpenModalDescartar(true);
  };

  const handleClickAvanzarProceso = (): void => {
    setIsOpenModalAvanzar(true);
  };

  const handleAvanzarCandidate = (): void => {
    // Avanzar desde esta etapa ahora lleva a Gestión de Ingreso (Citado), no a
    // Operaciones. estadoDestino hace que el backend lo rechace si el flujo de la
    // base todavía apunta a otra etapa.
    handleAvanzarProceso({
      setIsOpenModalNoProcesado,
      localStorageSelect,
      estadoDestino: ESTADO_CITADO,
    });
    setIsOpenModalAvanzar(false);
    const body = document.querySelector("body");
    if (body) {
      body.style.overflowY = "auto";
    }
    if (token) {
      refreshTable();
      setListadoSeleccionado([]);
    }
  };

  const handleClickStatusEntrevista = async (): Promise<void> => {
    const arrayList = currentProcesos.filter((item: any) =>
      listadoSeleccionado.includes(item.personaDNI)
    );
    const personas = arrayList.map((item: any) => {
      const { busPerId, entrevistaRealizada } = item;
      return {
        busPerId,
        entrevistaRealizada: true,
      };
    });
    await putEntrevistaRealizada({ token, personas });
    await refreshTable();
  };

  const handleClickNomina = async (): Promise<void> => {
    if (token) {
      try {
        if (localStorage.getItem(localStorageFilter)) {
          const copyStorage: any = localStorage.getItem(localStorageFilter);
          const dataObject = JSON.parse(copyStorage);
          filtrosExcel.proceso = dataObject.proceso?.map((valor: any) =>
            parseInt(valor)
          );
          filtrosExcel.cliente = [...dataObject.cliente];
        }
        filtrosExcel.busPerIdList = listadoSeleccionado.length > 0
          ? (listaCandidatoSeleccionado || [])
              .flatMap(({ grupos }: any) => grupos || [])
              .flatMap(({ procesos }: any) => procesos || [])
              .flatMap(({ personas }: any) => personas || [])
              .filter(({ personaDNI }: any) => listadoSeleccionado.includes(personaDNI))
              .map(({ busPerId }: any) => busPerId)
              .filter(Boolean)
          : [];
        await postGenerarExcel({
          token,
          estadosExcel,
          filtrosExcel,
          setIsLoading: setIsLoadingExcel,
        });
      } catch (error) {
        console.log("error descarga");
      }
    }
  };

  const handleDownloadPsicolaboral = (): void => {
    setIsOpenModalDownPsicolaboral(true);
  };

  const handleClickViewPdf = () => {
    try {
      getListadoPdf({ selectCurrent });
      setIsOpenModalDownPsicolaboral(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [isLoadingFicha, setIsLoadingFicha] = useState<boolean>(false);
  const handleDownloadFichas = async (): Promise<void> => {
    if (isLoadingFicha || !buttonEnabled) return;
    setIsLoadingFicha(true);
    try {
      const candidates = currentProcesos
        .filter((item: any) => listadoSeleccionado.includes(item.personaDNI))
        .map((item: any) => ({ rut: item.personaDNI, busPerId: item.busPerId }));
      await downloadFichaLegacyByRuts(candidates);
    } catch (error) {
      console.log("ERROR DESCARGANDO FICHAS", error);
    } finally {
      setIsLoadingFicha(false);
    }
  };

  return (
    <>
      <div className="container-actions w-100">
        {GESTION_INGRESO_VISIBLE && (
          <div className="content-button-masive">
            <button
              className={`button-navegation ${
                buttonEnabled ? "verde" : "disabled"
              }`}
              onClick={() => handleClickAvanzarProceso()}
              disabled={!buttonEnabled}
            >
              Gestionar Ingreso
              <ArrowForwardIcon />
            </button>
          </div>
        )}

        {onSearch && (
          <div
            style={{
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              margin: "0 16px",
            }}
          >
            <TableSearchInput
              value={searchValue ?? ""}
              onSearch={onSearch}
              placeholder="Buscar en la tabla…"
              height={40}
            />
          </div>
        )}

        <div className="content-actions-masive" style={{ marginLeft: "auto" }}>
          <BotonExcelMasterRex
            listadoSeleccionado={listadoSeleccionado}
            estadosExcel={estadosExcel}
            filtrosExcel={filtrosExcel}
            localStorageFilter={localStorageFilter}
          />

          <Tooltip text={isLoadingFicha ? "Generando fichas…" : "Descargar Ficha"}>
            <button
              className={`button-actions ${
                buttonEnabled && !isLoadingFicha ? "active-rojo" : "disabled"
              }`}
              disabled={!buttonEnabled || isLoadingFicha}
              onClick={handleDownloadFichas}
            >
              {isLoadingFicha ? (
                <IconCargando fill="#D32F2F" />
              ) : (
                <PictureAsPdfIcon style={{ fontSize: 20 }} />
              )}
            </button>
          </Tooltip>

          {/* <Tooltip text="Descarga Informe Psicolaboral">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-verde" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleDownloadPsicolaboral}
            >
              <IconDescargaPsicolaboral
                fill="#06A502"
                disabled={!buttonEnabled}
              />
            </button>
          </Tooltip> */}

          <Tooltip text="Solicitar Candidato">
            <button
              className={`button-actions ${buttonEnabled ? "active-solicitar-candidato" : "disabled"}`}
              disabled={!buttonEnabled}
              onClick={() => {
                const filtered = currentProcesos
                  .filter((item: any) => listadoSeleccionado.includes(item.personaDNI) && item.reclutadorId !== userId)
                  .map((item: any) => item.personaDNI);
                setRutSolicitar(filtered);
                setSelectedProcesoDestino(undefined);
                setSelectedComentario("");
                setIsOpenModalSolicitar(true);
              }}
            >
              <IconSolicitarCandidato fill={"#E3A000"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>
          <Tooltip text="Entrevista Realizada">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-naranjo" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleClickStatusEntrevista}
            >
              <IconCheck fill={"#FF4900"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>
          <Tooltip text="Bloquear">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-block" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleClickBloquearCandidato}
            >
              <IconBloquear fill={"#BE2A2A"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>
          <Tooltip text="Descartar">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-block" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleClickDescartarCandidato}
            >
              <IconDescarte fill={"#BE2A2A"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>

          <Tooltip text="Descargar Nómina">
            <button
              className={`button-actions ${
                isLoadingExcel ? "disabled file" : "active-file"
              }`}
              onClick={() => handleClickNomina()}
            >
              {isLoadingExcel ? (
                <IconCargando fill="#327a30" />
              ) : (
                <IconDescargaNomina fill="#327a30" />
              )}
            </button>
          </Tooltip>

          <ColumnVisibilityMenu
            variant="icon"
            columns={columnDefinitions as { key: string; label: string }[]}
            visibleKeys={visibleColumnKeys}
            onChange={setVisibleColumnKeys}
            isSaving={isSavingColumns}
            isSynchronized={isColumnsSynchronized}
          />

          <Tooltip text="Filtros">
            <button
              type="button"
              aria-label="Filtros"
              className="button-actions active-azul"
              onClick={() => setOpenModalFiltro((prev) => !prev)}
            >
              {dataObject ? (
                <FilterAltIcon style={{ fontSize: 24 }} />
              ) : (
                <FilterAltOutlinedIcon style={{ fontSize: 24 }} />
              )}
            </button>
          </Tooltip>
        </div>
      </div>

      {openModalFiltro && (
        <FiltroGenerico
          inline
          title="Filtros"
          localStorageFilter={localStorageFilter}
          onBack={() => setOpenModalFiltro(false)}
          onValueChange={setFormFilter}
          onPropertyChange={formFilter}
        >
          <div style={{ display: "none" }}>
          <StateFiltro
            layer="ESTADO"
            listState={["COMPLETO", "INCOMPLETO"]}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="estado"
          />
          </div>
          <InputFiltro
            layer="NOMBRE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="nombre"
          />
          <InputFiltro
            layer="RUT"
            typeFilter="rut"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="rut"
          />
          <InputFiltro
            layer="ID PROCESO"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="proceso"
          />
          <InputFiltro
            layer="CLIENTE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="cliente"
          />
          <InputFiltro
            layer="FECHA VALIDACIÓN"
            typeFilter="date"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="fechaValidacion"
          />
          <StateFiltro
            layer="ENTREVISTA REALIZADA"
            listState={["SI", "NO"]}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="entrevistaRealizada"
          />
          <InputFiltro
            layer="RECLUTADOR"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="reclutador"
          />
          {/* Estado de la validacion de cedula. Va ultimo porque es el mas
              nuevo y el menos usado: los filtros de siempre no se mueven. */}
          <StateFiltro
            layer="VALIDACIÓN"
            listState={OPCIONES_FILTRO_CEDULA}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="cedula"
          />
        </FiltroGenerico>
      )}

      {isOpenModalAvanzar && (
        <ModalGenerico
          title="CONFIRMAR MOVIMIENTO DE ETAPA"
          width="w-70"
          subtitle="Estás por mover de etapa a la siguiente selección: "
          onChangeBack={() => {
            setIsOpenModalAvanzar(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => handleAvanzarCandidate()}
          buttonBackText="Cancelar"
          buttonGoText="Aceptar"
        >
          <ModalAvanzarProceso
            listCandidate={listadoSeleccionado}
            listData={currentProcesos}
            setCandidates={setCandidates}
            etapa="Gestión de Ingreso (Citado)"
          />
        </ModalGenerico>
      )}

      {isOpenModalNoProcesado && (
        <ModalGenerico
          title="Candidatos No Enviados"
          iconTitle="danger"
          width="w-70"
          subtitle="Los siguiente candidatos no pudieron ser procesados:"
          onChangeBack={() => {
            setIsOpenModalNoProcesado(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          buttonBackText="Cerrar"
        >
          <Suspense fallback={<div>Cargando pruebitas...</div>}>
            <LazyNoProcesados list={listaNoProcesadosSeleccion ?? []} />
            {/* <ModalNoProcesadoSeleccion list={listaNoProcesadosSeleccion ?? []} /> */}
          </Suspense>
        </ModalGenerico>
      )}

      {isOpenModalBloquear && (
        <ModalGenerico
          title="BLOQUEO DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por bloquear la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalBloquear(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="bloqueo"
            getListRefresh={refreshTable}
            setListadoSeleccionado={setListadoSeleccionado}
            listSelect={currentProcesos ?? []}
            localStorageFilter={localStorageFilter}
            localStorageSelect={localStorageSelect}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalBloquear(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={listadoSeleccionado}
          />
        </ModalGenerico>
      )}

      {isOpenModalDescartar && (
        <ModalGenerico
          title="DESCARTE DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por descartar la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalDescartar(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="descarte"
            getListRefresh={refreshTable}
            setListadoSeleccionado={setListadoSeleccionado}
            listSelect={currentProcesos ?? []}
            localStorageFilter={localStorageFilter}
            localStorageSelect={localStorageSelect}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalDescartar(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={listadoSeleccionado}
          />
        </ModalGenerico>
      )}

      {isOpenModalDownPsicolaboral && (
        <ModalGenerico
          title="GENERAR INFORME PSICOLABORAL"
          width="w-70"
          subtitle="Estás por generar el informe psicolaboral para la siguiente selección de evaluaciones:"
          positionSubTitle="start"
          messageBottom="Puede encontrar los documentos en tu carpeta de descargas. Para continuar presione Descargar Informe."
          positionMessageBottom="start"
          buttonBackText="Cancelar"
          buttonGoText="Descargar Informe"
          buttonGoDisable={modalPdfDisabled}
          buttonDisabledTooltipText={"Favor seleccione el tipo de formato del pdf"}
          onChangeBack={() => {
            setIsOpenModalDownPsicolaboral(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            handleClickViewPdf();
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDownloadPsicolaboral
            list={listadoSeleccionado}
            listOriginal={listaCandidatoSeleccionado}
            token={token}
            selectCurrent={selectCurrent}
            setSelectCurrent={setSelectCurrent}
            tipoDocumentoAll={selectCurrent}
            setTipoDocumentoAll={setSelectCurrent}
            listaFormatoPsicolaboral={listaFormatoPsicolaboral}
          />
        </ModalGenerico>
      )}

      {isOpenModalSolicitar && (
        <ModalGenerico
          width="w-90"
          title="SOLICITAR CANDIDATO"
          onChangeBack={() => {
            setIsOpenModalSolicitar(false);
            setRutSolicitar([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
          buttonBackText="Cerrar"
          buttonGoText="Solicitar"
          buttonGoStyle="confirm"
          buttonGoDisable={!!selectedProcesoDestino}
          onChangeGo={() => {
            handleClickSolicitarCandidato({ procesoDestino: selectedProcesoDestino, comentario: selectedComentario });
            setIsOpenModalSolicitar(false);
            setRutSolicitar([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
        >
          <ModalSolicitarRegistro
            rut={rutSolicitar}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            onChangeBack={() => {
              setIsOpenModalSolicitar(false);
              setRutSolicitar([]);
              setSelectedProcesoDestino(undefined);
              setSelectedComentario("");
            }}
            handleClickSolicitarCandidato={handleClickSolicitarCandidato}
            onSelectProceso={(value: string) => setSelectedProcesoDestino(value)}
            onComentario={(value: string) => setSelectedComentario(value)}
            masivo={true}
          />
        </ModalGenerico>
      )}
    </>
  );
};

export default ActionMassive;
